import React from 'react';
import { MenuItem, TextField, Popper, Autocomplete } from '@mui/material';
import { makeStyles } from '@mui/styles';

import { LocationIcon, CheckmarkIcon } from '../icons';
import palette from '../styles/palette';

const useStyles = makeStyles(() => ({
  container: {
    minWidth: '10.938rem',
    maxWidth: '10.938rem',
  },
  iconContainer: {
    width: '1rem',
    paddingLeft: '0.625rem',
  },
  selectItem: {
    height: '1.5rem',
    width: '100%',
    display: 'flex',
    fontSize: '0.875rem',
    justifyContent: 'space-between',
  },
  popupIndicatorOpen: {
    transform: 'rotate(0)',
  },
  inputRoot: {
    marginTop: '0.063rem',
  },
  input: {
    textAlign: 'right',
    fontSize: '0.75rem',
    color: 'white',

    '&::selection': {
      background: palette.typography.white.disabled,
    },
  },
  endAdornment: {
    '&.MuiAutocomplete-endAdornment': {
      position: 'absolute',
      right: 0,
      top: 'auto',
      transform: 'none',
    },
  },
  option: {
    padding: 0,
  },
  noOption: {
    padding: '0.5rem 1rem',
  },
}));

const Dropdown = ({ value, items = [], onChange, onInputBlur }) => {
  const styles = useStyles();

  return (
    <Autocomplete
      options={items}
      value={value}
      PopperComponent={(props) => (
        <Popper
          {...props}
          style={{ marginTop: '-0.22rem' }}
          placement="bottom-end"
        />
      )}
      onChange={(e, option) => {
        value !== option.value && onChange(option.value);
      }}
      popupIcon={<LocationIcon />}
      sx={{ display: 'flex', alignItems: 'center' }}
      classes={{
        root: styles.container,
        popupIndicatorOpen: styles.popupIndicatorOpen,
        inputRoot: styles.inputRoot,
        input: styles.input,
        endAdornment: styles.endAdornment,
        option: styles.option,
        noOptions: styles.noOption,
      }}
      disableClearable
      isOptionEqualToValue={(option, value) => option.value === value}
      getOptionLabel={(option) => {
        if (!option) {
          return '';
        }

        return typeof option === 'string'
          ? items.find(({ value: optionValue }) => value === optionValue)?.label
          : (option.label ?? null);
      }}
      renderOption={(props, { value: itemValue, label }) => (
        <MenuItem
          {...props}
          value={itemValue}
          key={itemValue}
          className={styles.selectItem}
          component="div"
        >
          {label}
          <div className={styles.iconContainer}>
            {value === itemValue && <CheckmarkIcon />}
          </div>
        </MenuItem>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="standard"
          onBlur={(e) => {
            onInputBlur && onInputBlur(e.target.value);
          }}
          InputProps={{
            ...params.InputProps,
            disableUnderline: true,
            'data-testid': 'autocomplete-input',
          }}
        />
      )}
    />
  );
};

export default Dropdown;
